/**
 * Labstep
 *
 * @module components/GroupAutoSharing/Action/Delete
 */

import { GroupAutoSharingFormDeleteContainer as GroupAutoSharingFormDelete } from 'labstep-web/components/GroupAutoSharing/Form/Delete';
import { ICONS } from 'labstep-web/constants/icons';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as ModalDefault } from 'labstep-web/core/Modal/Default';
import type React from 'react';
import type { GroupAutoSharingActionDeleteProps } from './types';

export const GroupAutoSharingActionDelete: React.FC<
  GroupAutoSharingActionDeleteProps
> = ({ groupAutoSharing }) => (
  <ModalDefault
    header="Delete an Autosharing Rule"
    viewComponent={({ toggleModal }) => (
      <ActionComponent
        onClick={toggleModal}
        type="icon"
        icon={ICONS.file.actions.delete}
      />
    )}
    content={({ toggleModal }) => (
      <GroupAutoSharingFormDelete
        body={{
          guid: groupAutoSharing.guid,
        }}
        options={{
          onSuccess: toggleModal,
          toast: true,
        }}
        groupAutoSharing={groupAutoSharing}
      />
    )}
  />
);
